import { type FC } from 'react';
import { motion } from 'framer-motion';

import { useAppSelector } from '@/redux/store';

import { ClaimLotteryRewards } from './ClaimLotteryRewards';

const ClaimLotteryRewardsModal: FC = () => {
  const isClaimRewards = useAppSelector(
    (state) => state.lottery.isClaimRewards,
  );

  if (!isClaimRewards) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed w-full h-full top-0 left-0 z-[999]"
    >
      <ClaimLotteryRewards />
    </motion.div>
  );
};

export { ClaimLotteryRewardsModal };
